//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import SocketService from "../SocketService.js";

const RestartSocketActionHandler = class RestartSocketActionHandelr {
  async handle(action, store) {
    SocketService.socket.close();
    store.state.Session.socketId = null;
    await SocketService.connect();
    this.$socketService.setHandler("getConnectionId", (data) => {
      this.$socket.socket_id = data.socket_id;
    });
    this.$socket.addEventListener("open", () => {
      let outData = {
        action: "getConnectionId",
        data: "",
      };
      this.$socket.send(JSON.stringify(outData));
    });
  }
};

export default RestartSocketActionHandler;
